import { MOBILE_APP, MOBILE_APP_FEATURES } from "../constants/mobileApp";

function storeHref(url, platform) {
  if (url) return url;
  return `mailto:${MOBILE_APP.supportEmail}?subject=${encodeURIComponent(
    `${platform} app access request`
  )}`;
}

export default function MobileAppPromo({ compact = false, variant = "light" }) {
  const hasAndroid = Boolean(MOBILE_APP.androidUrl);
  const hasIos = Boolean(MOBILE_APP.iosUrl);
  const isHero = variant === "hero";

  return (
    <div
      className={[
        "auth-mobile-app",
        compact && "auth-mobile-app--compact",
        isHero && "auth-mobile-app--hero",
      ]
        .filter(Boolean)
        .join(" ")}
    >
      {!isHero && (
        <div className="auth-mobile-app-head">
          <span className="auth-mobile-app-icon" aria-hidden="true">
            <i className="fas fa-mobile-alt" />
          </span>
          <div>
            <strong>Get the {compact ? "" : "NextFollowUp "}mobile app</strong>
            <span>Same login — leads, follow-ups &amp; attendance in your pocket</span>
          </div>
        </div>
      )}

      {isHero && (
        <p className="auth-mobile-app-hero-copy">
          Same login — manage leads, follow-ups &amp; geo attendance on the go.
        </p>
      )}

      <ul className="auth-mobile-app-features">
        {MOBILE_APP_FEATURES.map((item) => (
          <li key={item.label}>
            <i className={item.icon} aria-hidden="true" />
            {item.label}
          </li>
        ))}
      </ul>

      <div className="auth-mobile-app-stores">
        <a
          className="auth-store-btn auth-store-btn--android"
          href={storeHref(MOBILE_APP.androidUrl, "Android")}
          target={hasAndroid ? "_blank" : undefined}
          rel={hasAndroid ? "noopener noreferrer" : undefined}
        >
          <i className="fab fa-google-play" aria-hidden="true" />
          <span>
            <small>{hasAndroid ? "Get it on" : "Request"}</small>
            Google Play
          </span>
        </a>
        <a
          className="auth-store-btn auth-store-btn--ios"
          href={storeHref(MOBILE_APP.iosUrl, "iOS")}
          target={hasIos ? "_blank" : undefined}
          rel={hasIos ? "noopener noreferrer" : undefined}
        >
          <i className="fab fa-apple" aria-hidden="true" />
          <span>
            <small>{hasIos ? "Download on the" : "Request"}</small>
            App Store
          </span>
        </a>
      </div>

      {!hasAndroid && !hasIos && (
        <p className="auth-mobile-app-note">
          Store links coming soon — tap a button to request app access from your admin.
        </p>
      )}
    </div>
  );
}
